<template>
    <div
        v-if="$slots.default"
        class="wysiwyg-content"
        :class="{ 'wysiwyg-compact': compact }"
    >
        <slot />
    </div>

    <div
        v-else-if="content"
        tabindex="0"
        class="wysiwyg-content"
        :class="{ 'wysiwyg-compact': compact }"
        v-html="sanitizeHtml(contentHtml)"
    ></div>
</template>

<script setup lang="ts">
import { normalizeUrlWithinAnchors } from '~/utils/helpers';

const props = withDefaults(
    defineProps<{
        content?: string | null;
        compact?: boolean;
    }>(),
    {
        content: '',
        compact: false,
    },
);

const contentHtml = computed(() => {
    let { content } = props;

    if (!content) {
        return '';
    }

    if (!content.includes('</p>')) {
        content = `<p>${content}</p>`;
    }

    content = content.replace(
        /src="([\s\S]+?)"/g,
        'src="\$1/m/fit-in/1086x0/filters:format(webp):quality(90)"',
    );
    content = content.replace(
        /target="_self" linktype="url"/g,
        'target="_blank" linktype="url"',
    );

    return normalizeUrlWithinAnchors(content);
});
</script>
<style scoped>
:deep(a:has(img)) {
    display: inline-block;
}
</style>
